import { updateSlimSelectValue } from "controllers/dropdown_controller"
import PreferencesBaseController from "controllers/preferences_base_controller"

export default class extends PreferencesBaseController {
  _updateUiElement(newValue) {
    updateSlimSelectValue(this.element, newValue)
  }

  _getCurrentValue() {
    return this.element.value
  }
}
